export default __webpack_public_path__ + "static/media/Plus_circle_LW.dfcee34d.svg";